export default "__VITE_ASSET__BCyAx6Ss__"